import Vue from 'vue'
import { abrirModalUrl } from './Modal'
import { inicializarVueNaPágina, inicializarVueNoElemento } from './VueHooks'
import { mobile } from '@Shared/Device'
import { getTransition, animateTransition, waitForCurrentAnimationToFinish } from '@App/Reflinks/Transition'
import '@App/Reflinks/Frame'
import '@App/Reflinks/Vue' // TODO <- remover
import { store } from '@App/Store/Store'
import axios from 'axios'
import nprogress from 'nprogress'

window.addEventListener('load', () => {
    window.history.replaceState({ reflinks: true }, document.title, location.href)

    if (document.location.pathname.indexOf('/chat/rooms') === 0) {
        let chat = document.querySelector('[data-reflinks-layout="chat"]')
        if (chat) chat.style.display = 'flex'
        document.querySelector('[data-reflinks-dynamic]').style.display = 'none'
    } else {
        inicializarVueNaPágina()
        let chat = document.querySelector('[data-reflinks-layout="chat"]')
        if (chat) chat.style.display = 'none'
        let dynamic = document.querySelector('[data-reflinks-dynamic]')
        if (dynamic) dynamic.style.display = 'flex'
    }

    new Vue({
        el: document.querySelector('[data-reflinks-layout="chat"]'),
        store: store,
    })
    inicializarVueNoElemento(document.querySelector('#menu-módulos'), true)
    inicializarVueNoElemento(document.querySelector('#footer-mobile'), false)
})

// Próximo changeset customziado para realizar alguma ação diferente do padrão da resposta do servidor.
let próximoChangesetHandler = null

export function próximoChangeset() {
    return próximoChangesetHandler
}

document.addEventListener('click', ev => {
    let anchor = identificarAnchor(ev.target)

    if (anchor) {
        if (!deveInterceptarClick(anchor)) {
            console.log('parando pora aqui...')
            return
        }

        próximoChangesetHandler = null

        let href = anchor.getAttribute('href')

        if (isFromDifferentDomain(href)) {
            location.href = href
            return
        }

        ev.preventDefault()

        if (anchor.hasAttribute('serializar-formulários')) {
            let formulários = eval('(' + anchor.getAttribute('serializar-formulários') + ')')

            for (let chave in formulários) {
                let form = document.querySelector(formulários[chave])
                if (form) {
                    let dados = new FormData(form)
                    let json = Object.fromEntries(new URLSearchParams(dados))

                    href += '&' + chave + '=' + encodeURIComponent(JSON.stringify(json))
                }
            }
        }

        if (anchor.getAttribute('target') == '_blank') {
            window.open(href)
            return
        }

        if (anchor.getAttribute('próximo-changeset')) {
            próximoChangesetHandler = eval('(' + anchor.getAttribute('próximo-changeset') + ')')
        }

        if (deveAbrirEmModal(anchor) && href && !mobile()) {
            abrirModalUrl(href, {
                layout: anchor.getAttribute('modal'),
            })
        } else if (href) {
            let opts = {}

            if (anchor.hasAttribute('target') && !mobile()) {
                opts.target = anchor.getAttribute('target') || undefined
            }

            visitarPágina(href, opts)
        }
    }
})

export function maybeAssignNextChangesetFromFormSubmit(form) {
    if (form.hasAttribute('próximo-changeset')) {
        próximoChangesetHandler = eval('(' + form.getAttribute('próximo-changeset') + ')')
    }
}

window.addEventListener('popstate', ev => {
    if (ev.state === null) {
        ev.preventDefault()
        return false
    }

    visitarPágina(document.location.href, {
        fromPopstate: true,
    })
})

const hooks = []
export function addRouteHook(url, callback) {
    hooks.push({ url, callback })
}

export async function visitarPágina(url, opts = {}) {
    let páginaAtual = parsePáginaAtual()

    if (páginaAtual && páginaAtual.content && páginaAtual.content.querySelector('[data-unsaved-changes]')) {
        if (!window.confirm(__('Você possuí alterações não salvas. Tem certeza que deseja prosseguir?'))) {
            return
        }
    }

    document.dispatchEvent(new CustomEvent('reflinks:before-load', { detail: url }))

    // Caso especial para tratar a rota /chat/rooms e apenas fazer um toggle no display para
    // dispositivos mais lentos.
    if (url.indexOf('/chat/rooms') !== -1) {
        document.body.querySelector('[data-reflinks-layout="chat"]').style.display = 'flex'
        document.body.querySelector('[data-reflinks-dynamic]').style.display = 'none'

        if (document.location.pathname !== url) {
            window.history.pushState({ reflinks: true }, 'teclia', url)
            document.dispatchEvent(new CustomEvent('reflinks:load', { detail: url }))
        }

        return
    }

    let hook = hooks.find(hook => url.indexOf(hook.url) !== -1)
    if (hook) {
        if (hook.callback() !== false) {
            window.history.pushState({ reflinks: true }, 'teclia', url)
            return
        }
    }

    // Caso especial para testes do Jest. Nós não devemos enviar de fato uma requisição pelo Axios,
    // mas sim apenas fingir que a visita foi feita. Isso é suficiente para testar a maior parte das interações
    // (exemplo: tal ação resulta em um redirect que deixa o usuário na página X).
    if (typeof jest !== 'undefined') {
        window.history.pushState({ reflinks: true }, 'teclia', url)
        document.dispatchEvent(new CustomEvent('reflinks:load', { detail: url }))
        return
    }

    await waitForCurrentAnimationToFinish()

    let transition = getTransition(url)
    let targetToReplace = páginaAtual.content

    if (transition) {
        targetToReplace = animateTransition(url, páginaAtual.content, transition)
    } else {
        nprogress.start()
    }

    // Se a ação de visitar estiver sendo enviada do evento 'popstate', nós não devemos inserir
    // um novo entry no history.
    if (!opts.fromPopstate) {
        window.history.pushState({ reflinks: true }, 'teclia', url)
    }

    if (url.indexOf('http') === -1) {
        let base = document.head.querySelector('base')
        if (base) {
            url = base.getAttribute('href') + url
        }
    }

    axios({
        url: url
            .replace(/\/\//g, '/')
            .replace(/https:\//, 'https://')
            .replace(/http:\//, 'http://'),
        method: 'GET',
        headers: {
            'X-Reflinks': '1',
            Accept: 'text/html',
        },
    })
        .then(res => {
            let chat = document.body.querySelector('[data-reflinks-layout="chat"]')
            if (chat) chat.style.display = 'none'

            document.body.querySelector('[data-reflinks-dynamic]').style.display = 'flex'

            let novaPágina = parseHtmlResponse(res.data)

            if (páginaAtual.layout == novaPágina.layout && targetToReplace) {
                targetToReplace.replaceWith(novaPágina.content)
                inicializarVueNoElemento(novaPágina.content)
            } else {
                páginaAtual.root.replaceWith(novaPágina.root)
                inicializarVueNaPágina()
            }

            if (novaPágina.title) {
                document.title = novaPágina.title
            }

            document.dispatchEvent(new CustomEvent('reflinks:load', { detail: url }))

            if (!transition) {
                nprogress.done()
            }
        })
        .catch(res => {
            console.log(res)
            nprogress.done()
            // TODO: Mostrar algum aviso de falha no modal
        })
}

/**
 * Retorna um objeto que descreve a página atual que está aberta, com elemento root, layout e elemento do conteúdo (content).
 *
 * @return {object}
 */
function parsePáginaAtual() {
    let root = document.body.querySelector('[data-reflinks-dynamic]')

    return {
        root,
        layout: root.dataset.reflinksLayout,
        content: root.querySelector('[data-reflinks-content]'),
    }
}

/**
 * Retorna um objeto que descreve a página recebida como resposta na requisição, com elemento root, layout e elemento do conteúdo.
 *
 * @param {string} html
 * @return {object}
 */
function parseHtmlResponse(html) {
    let doc = document.createElement('html')
    doc.innerHTML = html

    let root = doc.querySelector('[data-reflinks-dynamic]')
    let title = doc.querySelector('title')

    return {
        root,
        title: title ? title.innerHTML : '',
        layout: root.dataset.reflinksLayout,
        content: root.querySelector('[data-reflinks-content]'),
    }
}

/**
 * Nós devemos interceptar o click somente para links internos da aplicação.
 * Links para outros sites devem seguir o fluxo padrão do navegador.
 *
 * @param {HTMLElement} anchor
 */
function deveInterceptarClick(anchor) {
    if (anchor.getAttribute('reflinks') == 'false') {
        return false
    }

    let url = anchor.getAttribute('href')

    if (!url || url.indexOf('#') === 0) return false

    return true
}

/**
 * O elemento clicado está pedindo para abrir em modal?
 *
 * @param {HTMLElement} target
 */
function deveAbrirEmModal(target) {
    return target.hasAttribute('modal')
}

/**
 * A navegação pelo Reflinks funciona interceptando clicks em todos os elementos. Caso exista um href para uma URL
 * dentro da própria aplicação nós fazemos uma visita pelo Reflinks. Algumas vezes, porém, o click é detectado
 * em um elemento <svg> dentro da tag <a>. Essa função é responsável por retornar a tag quem contém o href - ou null.
 *
 * @param {HTMLElement} target
 */
function identificarAnchor(target) {
    if (target.hasAttribute('href')) return target

    let parent = target.parentElement
    while (parent) {
        if (parent.hasAttribute('href')) return parent
        parent = parent.parentElement
    }
}

/**
 * É de um domínio diferente do que estamos rodando atualmente?
 *
 * @param {string} href
 * @returns {boolean}
 */
function isFromDifferentDomain(href) {
    console.log({ href })

    // Não inicia com "/" nem com "http", algo do tipo "form.html?foo=bar"
    if (href.match(/^[a-z0-9A-Z]/) && href.indexOf('http') === -1) return false

    if (href.indexOf('/') === 0) return false
    if (href.indexOf(location.origin) === 0) return false

    return true
}
